import React, { useState } from 'react';
import { Button, Tooltip, Modal } from 'antd';
import { ImportOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import DataImportForm from './DataImportForm';
import { IMPORTABLE_RESOURCE_VALUES } from './constants';

const IMPORTABLE_RESOURCE_SET = new Set(IMPORTABLE_RESOURCE_VALUES);

const ImportButton = ({ resource, type = 'primary', ghost = false, size = 'middle' }) => {
    const { t } = useTranslation();
    const [isModalVisible, setIsModalVisible] = useState(false);

    if (resource && !IMPORTABLE_RESOURCE_SET.has(resource)) {
        return null;
    }

    const handleSuccess = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <Tooltip title={t('import_data')}>
                <Button
                    type={type}
                    ghost={ghost}
                    size={size}
                    icon={<ImportOutlined />}
                    onClick={() => setIsModalVisible(true)}
                >
                    {t('import')}
                </Button>
            </Tooltip>
            <Modal
                title={t('import_data')}
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={700}
                destroyOnClose
            >
                <DataImportForm defaultResources={resource ? [resource] : undefined} onSuccess={handleSuccess} />
            </Modal>
        </>
    );
};

export default ImportButton;
